import { useEffect } from 'react';
import { X } from 'lucide-react';
import { useEnvio } from '../../application/dependencias';

/** Aviso do sistema: mensagem curta no rodapé da tela (envio, vínculo, Telegram, convites), que some sozinha. */
export function AvisoSistema() {
  const aviso = useEnvio((s) => s.aviso);
  const limpar = useEnvio((s) => s.limparAviso);
  useEffect(() => {
    if (!aviso) return;
    const relogio = setTimeout(limpar, 8000);
    return () => clearTimeout(relogio);
  }, [aviso, limpar]);
  if (!aviso) return null;
  return (
    <div className="aviso-envio" role="status">
      {aviso}
      <button type="button" aria-label="Fechar aviso" onClick={limpar}>
        <X size={14} aria-hidden />
      </button>
    </div>
  );
}
